import React, { useEffect, useState } from "react";
import SkeletonTable from "../../components/table/SkeletonTable";
import columns from "../../columns/activity/activity";
import moment from "moment";
import { GetActivityApi } from "../../api/request/activity/activity";

const Activity = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getActivity = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetActivityApi();
      setData(
        data?.data?.map((item) => {
          return {
            ...item,
            created_at: item?.created_at
              ? moment(item?.created_at).format("lll")
              : "--",
          };
        })
      );
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getActivity();
  }, []);

  return (
    <div className="border rounded-xl bg-white">
      <div className="flex justify-between mx-5 mt-5">
        <p className="title">Activity</p>
      </div>
      <div className="mt-5">
        <SkeletonTable columns={columns} data={data} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default Activity;
